<div class="help-button">
  <button
    #triggerEl
    type="button"
    class="btn btn-ghost btn-circle"
    aria-label="Help and Support"
    [attr.aria-expanded]="menuOpen ? 'true' : 'false'"
    [attr.aria-controls]="menuId"
    data-testid="help-button-trigger"
    (click)="toggleMenu($event)">
    <app-icon name="help" size="md"></app-icon>
  </button>

  @if (menuOpen) {
    <ul
      #menuEl
      popover="manual"
      aria-label="Help and Support"
      [id]="menuId"
      data-testid="help-button-menu"
      class="help-button-menu menu p-2 shadow-lg bg-base-100 rounded-box border border-base-300"
      [style.top.px]="placement.top"
      [style.left.px]="placement.left"
      [style.width.px]="placement.width"
      [style.max-height.px]="placement.maxHeight">
      <li>
        <a (click)="navigateToHelp()">
          <app-icon name="help_center" size="sm"></app-icon>
          Help Center
        </a>
      </li>
      <li>
        <a (click)="navigateToTutorials()">
          <app-icon name="play_circle" size="sm"></app-icon>
          Video Tutorials
        </a>
      </li>
      <li>
        <a (click)="navigateToFAQ()">
          <app-icon name="quiz" size="sm"></app-icon>
          FAQs
        </a>
      </li>
      <li class="divider"></li>
      <li>
        <a (click)="openKeyboardShortcuts()">
          <app-icon name="keyboard" size="sm"></app-icon>
          Keyboard Shortcuts
        </a>
      </li>
      <li>
        <a (click)="reportIssue()">
          <app-icon name="bug_report" size="sm"></app-icon>
          Report an Issue
        </a>
      </li>
      <li class="divider"></li>
      <li>
        <a href="mailto:support@coursebuilder.com" (click)="closeMenu()">
          <app-icon name="email" size="sm"></app-icon>
          Contact Support
        </a>
      </li>
    </ul>
  }
</div>
